import { render, staticRenderFns } from "./MainInformationCard.vue?vue&type=template&id=5062154f"
import script from "./MainInformationCard.vue?vue&type=script&lang=js"
export * from "./MainInformationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports